import { getAvatarUrl, getUserInitials } from '../../utils/avatarHelpers'

/**
 * Componente Avatar reutilizable para mostrar avatares de usuarios
 * @param {Object} props
 * @param {Object} props.user - Objeto de usuario
 * @param {string} props.size - Tamaño del avatar: 'sm', 'md', 'lg', 'xl' o tamaño personalizado
 * @param {string} props.className - Clases CSS adicionales
 * @param {boolean} props.showStatus - Mostrar indicador de estado activo
 * @param {string} props.statusColor - Color del indicador de estado (default: 'green')
 */
export default function Avatar({ 
  user, 
  size = 'md', 
  className = '',
  showStatus = false,
  statusColor = 'green'
}) {
  const avatarUrl = getAvatarUrl(user)
  const userInitials = getUserInitials(user)
  
  // Usar avatarUpdatedAt como key para forzar re-render cuando cambia el avatar
  const avatarKey = user?.avatarUpdatedAt || avatarUrl || userInitials

  const sizeClasses = {
    sm: 'w-8 h-8 text-xs',
    md: 'w-10 h-10 text-sm',
    lg: 'w-12 h-12 text-base',
    xl: 'w-16 h-16 text-xl',
  }

  const sizeClass = sizeClasses[size] || size

  const statusColors = {
    green: 'bg-green-400 border-teal-600',
    red: 'bg-red-400 border-red-600',
    yellow: 'bg-yellow-400 border-yellow-600',
    blue: 'bg-blue-400 border-blue-600',
  }

  const statusColorClass = statusColors[statusColor] || statusColors.green

  return (
    <div className={`relative inline-block ${className}`}>
      {avatarUrl ? (
        <img
          key={avatarKey}
          src={avatarUrl}
          alt={user?.nombre || 'Usuario'}
          className={`${sizeClass} rounded-full object-cover border-2 border-pastel-pink dark:border-gray-700`}
          onError={(e) => {
            e.target.style.display = 'none'
            e.target.nextElementSibling.style.display = 'flex'
          }}
        />
      ) : null}
      <div 
        className={`${sizeClass} rounded-full bg-gradient-to-br from-pastel-teal to-primary-500 flex items-center justify-center text-white font-semibold border-2 border-pastel-pink dark:border-gray-700 ${avatarUrl ? 'hidden' : 'flex'}`}
      >
        {userInitials}
      </div>
      {showStatus && (
        <div className={`absolute bottom-0 right-0 w-3 h-3 ${size === 'xl' ? 'w-4 h-4' : ''} ${size === 'sm' ? 'w-2 h-2' : ''} ${statusColorClass} rounded-full border-2 border-white dark:border-gray-800`}></div>
      )}
    </div>
  )
}
